var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject } from "~/core/decorator";
import { Service } from "~/core/service";
var CustConfigService = /** @class */ (function (_super) {
    __extends(CustConfigService, _super);
    function CustConfigService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询调记配置
     */
    CustConfigService.prototype.getConfigByPrin = function (principalId, loading) {
        return this.netService.send({
            server: managementService.custConfig.getConfigByPrin,
            data: {
                principalId: principalId,
            },
            loading: loading,
        });
    };
    /**
     * 查询所有颜色
     */
    CustConfigService.prototype.getAllColors = function (loading) {
        return this.netService.send({
            server: managementService.custConfig.getAllColors,
            loading: loading,
        });
    };
    /**
     *
     * @param data 查询参数
     * @param loading 加载等待框
     */
    CustConfigService.prototype.getPrimaryFields = function (data, loading) {
        return this.netService.send({
            server: managementService.custConfig.getPrimaryFields,
            data: data,
            loading: loading,
        });
    };
    /**
     *
     * @param data 查询关系
     * @param loading 加载等待框
     */
    CustConfigService.prototype.getRelationShip = function (data, loading) {
        return this.netService.send({
            server: managementService.custConfig.getRelationShip,
            data: data,
            loading: loading,
        });
    };
    /**
     *
     * @param data 查询电话类型
     * @param loading 加载等待框
     */
    CustConfigService.prototype.getPhoneType = function (data, loading) {
        return this.netService.send({
            server: managementService.custConfig.getPhoneType,
            data: data,
            loading: loading,
        });
    };
    /**
     *
     * @param data 查询地址类型
     * @param loading 加载等待框
     */
    CustConfigService.prototype.getAddressType = function (data, loading) {
        return this.netService.send({
            server: managementService.custConfig.getAddressType,
            data: data,
            loading: loading,
        });
    };
    /**
     *
     * @param data 查询地址状态
     * @param loading 加载等待框
     */
    CustConfigService.prototype.getAddressStatus = function (data, loading) {
        return this.netService.send({
            server: managementService.custConfig.getAddressStatus,
            data: data,
            loading: loading,
        });
    };
    /**
     *
     * @param data 查询地址状态
     * @param loading 加载等待框
     */
    CustConfigService.prototype.getContactResult = function (data, loading) {
        return this.netService.send({
            server: managementService.custConfig.getContactResult,
            data: data,
            loading: loading,
        });
    };
    __decorate([
        Inject(NetService)
    ], CustConfigService.prototype, "netService", void 0);
    return CustConfigService;
}(Service));
export { CustConfigService };
